import { Component, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
	selector: 'app-plan-tooltip',
	template: `<p>
		Disponível na versão {{ plan }}.
		<a href="https://www.advtecnologia.com.br/portal-b2b/" target="_blank"
			>Saber mais</a
		>
	</p>`,
	styleUrls: ['./plan-tooltip.component.scss'],
})
export class PlanTooltipComponent implements OnInit, OnDestroy {
	@Input() plan = 'PRO';
	constructor() {}

	ngOnInit(): void {}

	ngOnDestroy(): void {}
}
